export default __webpack_public_path__ + "static/media/ButtonFaux.c9e60f8f.png";